import AbstractAsset from '@/editor/assets/abstract.asset'

export default class D2Asset extends AbstractAsset {
  constructor(uuid) {
    super(uuid)
    this._type = 'd2'
    this._props = {
      ...this._props,
      'position.x': 0,
      'position.y': 0,
      gscale: 1,
      'scale.x': 1,
      'scale.y': 1,
      'rotation.z': 0,
      opacity: 1,
    }
  }

  get D() {
    return 2
  }

  get PROPS() {
    return {
      position: {
        // machine-readable
        type: 'object',
        name: 'Position', // human readable
        tool: 'Translate2D',
        fields: {
          x: { type: 'number', name: 'X' },
          y: { type: 'number', name: 'Y' },
        },
      },
      gscale: {
        type: 'number',
        name: 'Scale'
      },
      scale: {
        type: 'object',
        name: 'Stretch',
        tool: 'Scale2D',
        fields: {
          x: { type: 'number', name: 'X' },
          y: { type: 'number', name: 'Y' },
        },
      },
      rotation: {
        type: 'object',
        name: 'Rotation',
        tool: 'Rotate2D',
        fields: {
          z: { type: 'number', name: 'Z' },
        },
      },
      opacity: {
        type: 'number',
        name: 'Opacity',
        normalized: true,
        tool: 'OpacitySlider',
      },
    }
  }

  initAnimation(settings, zeroFrame) {
    const animation = super.initAnimation(settings)
    this.dbg.log('zf', zeroFrame, this._asset.meta)
    let scale = 1
    const mw = Number(this._asset?.meta?.width)
    const mh = Number(this._asset?.meta?.height)
    const hasDims = Number.isFinite(mw) && mw > 0 && Number.isFinite(mh) && mh > 0
    if (
      !zeroFrame ||
      !hasDims ||
      (mh < zeroFrame.height &&
        mh < zeroFrame.height)
    ) {
      scale = 1
    } else {
      // not fits to screen, scale down
      scale = Math.min(
        zeroFrame.width / mw,
        zeroFrame.height / mh
      )
    }
    if (!Number.isFinite(scale) || scale <= 0) scale = 1
    // Apply fit-to-screen as default props so V2 (no keys) renders correctly
    this._props['scale.x'] = scale
    this._props['scale.y'] = scale
    this._props.opacity = 1
    if (animation.keyframes[0]) {
      animation.keyframes[0].props['scale.x'] = scale
      animation.keyframes[0].props['scale.y'] = scale
      animation.keyframes[0].easing['scale.x'] = 'Linear.None'
      animation.keyframes[0].easing['scale.y'] = 'Linear.None'
      animation.keyframes[0].delay['scale.x'] = 0
      animation.keyframes[0].delay['scale.y'] = 0
      animation.keyframes[0].props.opacity = 1
      animation.keyframes[0].easing.opacity = 'Linear.None'
      animation.keyframes[0].delay.opacity = 0
    }

    if (animation.keyframes[1]) animation.keyframes[1].props.opacity = 1
    return animation
  }

  updateFrame(time, localTime, frame, zf, isPlay, propsUp) {
    this.dbg.log('updateFrame', time, localTime, frame)
    const props = typeof propsUp === 'undefined'
      ? super.updateFrame(time, localTime, frame)
      : propsUp
    if (!frame || !frame.animation || !frame.mesh || !frame.strip) return props
    if (localTime < 0 || localTime > frame.strip.length) {
      this.dbg.info('invisible')
      frame.mesh.visible = false
      frame.mesh.layers.set(2)
      return props
    }
    this.dbg.log('localTime', localTime, frame)
    frame.mesh.visible = true
    frame.mesh.layers.set(1)
    this.dbg.log('updateFrame', { time, localTime, frame, props })
    Object.keys(props).forEach((prop) => {
      switch (prop) {
        case 'scale.x':
          frame.mesh.scale.x = props[prop]
          break
        case 'scale.y':
          frame.mesh.scale.y = props[prop]
          break
        case 'position.x':
          frame.mesh.position.x = props[prop]
          break
        case 'position.y':
          frame.mesh.position.y = props[prop]
          break
        case 'rotation.z':
          frame.mesh.rotation.z = props[prop]
          break
        case 'opacity':
          if (frame.material)
            frame.material.opacity = props[prop]
          break
      }
    })
    return props
  }

  toolUpdate(update) {
    const ret = super.toolUpdate(update)
    this.dbg.log('toolUpdate', update)
    if (update.tool === 'Translate2D') {
      ret['position.x'] = update.position.x
      ret['position.y'] = update.position.y
    }
    if (update.tool === 'Scale2D') {
      ret['scale.x'] = update.scale.x
      ret['scale.y'] = update.scale.y
    }
    if (update.tool === 'Rotate2D') {
      ret['rotation.z'] = update.rotation._z
    }
    if (update.tool === 'Rotate3D') {
      ret['rotation.x'] = update.rotation._x
      ret['rotation.y'] = update.rotation._y
      ret['rotation.z'] = update.rotation._z
    }
    if (update.tool === 'OpacitySlider') {
      ret.opacity = update.opacity
    }
    return ret
  }
}
